<template>
  <div class="bg-black overflow-hidden w-full relative h-full pb-6 md:pb-0">
    <BaseContainer class="!px-0 md:!px-5">
      <div class="flex flex-col-reverse md:grid grid-cols-2">
        <div
          class="space-y-6 pt-8 pb-[58px] md:py-[90px] md:mr-[64px] px-5 md:px-0"
        >
          <div class="text-primary-white space-y-2">
            <div class="font-bold">{{ $t('landing.subTitleArticle') }}</div>
            <div class="text-5xl">
              {{
                locale === 'en' ? props.titleEn : props.titleTh || props.titleEn
              }}
            </div>
            <div>
              {{
                locale === 'en'
                  ? props.descriptionEn
                  : props.descriptionTh || props.descriptionEn
              }}
            </div>
          </div>
          <Button
            class="min-w-[224px]"
            icon="arrow-up-right"
            @click="() => router.push(localePath(props.url))"
          >
            {{
              locale === 'en'
                ? props.buttonTitleEn
                : props.buttonTitleTh || props.buttonTitleEn
            }}</Button
          >
        </div>
        <div class="overflow-hidden w-full">
          <NuxtImg
            format="webp"
            loading="lazy"
            alt="article link"
            :src="props.image"
            class="w-full hidden md:block md:w-[50vw] min-h-[300px] md:h-full object-cover object-center md:absolute"
          />
          <NuxtImg
            format="webp"
            loading="lazy"
            alt="article link"
            :src="props.imageMobile || props.image"
            class="w-full block md:hidden md:w-[50vw] min-h-[300px] md:h-full object-cover object-center md:absolute"
          />
        </div>
      </div>
    </BaseContainer>
  </div>
</template>

<script lang="ts" setup>
const router = useRouter()
const { locale } = useI18n()
const localePath = useLocalePath()

const props = defineProps<{
  titleEn: string
  descriptionEn: string
  titleTh: string
  descriptionTh: string
  buttonTitleEn: string
  buttonTitleTh: string
  url: string
  image: string
  imageMobile?: string
}>()
</script>
